import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21e5c44c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "align-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-info" }, "生产模式：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-info" }, "首/返单：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-info" }, "订单次数：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-info" }, "订单号：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_ImageViewer = _resolveComponent("ImageViewer")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CopyText = _resolveComponent("CopyText")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!
  const _component_Logger = _resolveComponent("Logger")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_page, { fheader: { showCollapse: false } }, {
      fheader: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "fixed-el-form-item-height",
          model: _ctx.params,
          "label-width": "110px",
          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "款式号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.styleCodeLike,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.styleCodeLike) = $event)),
                  placeholder: "请输入款式号",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "订单号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.orderCodeLike,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.orderCodeLike) = $event)),
                  placeholder: "请输入订单号",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { "label-width": "40px" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleReset()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      main: _withCtx(({ height }) => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          height: height,
          key: height,
          data: _ctx.tableData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "图片",
              "min-width": "100",
              prop: "stylePictureList",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                (row?.stylePictureList?.[0])
                  ? (_openBlock(), _createBlock(_component_ImageViewer, {
                      key: 0,
                      list: row.stylePictureList
                    }, {
                      default: _withCtx(({ view }) => [
                        _createVNode(_component_el_image, {
                          src: _ctx.$filters.ossUrl(row?.stylePictureList?.[0]),
                          class: "img-thumbnail__table",
                          fit: "cover",
                          onClick: view
                        }, null, 8, ["src", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["list"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "款式号",
              "min-width": "140",
              prop: "styleCode",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_CopyText, null, {
                  default: _withCtx(() => [
                    (_ctx.$has(_ctx.permissionConfig.EDIT) && row.styleCode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                  name: 'ProductionDemandProductionEdit',
                  params: { id: row.demandDetailId },
                }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.styleCode || '-'), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.styleCode || '-'), 1))
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", null, [
                  (row.regionId)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "danger",
                        effect: "plain",
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.REGION_LIST, row.regionId)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (row.sampleSwapProdCount === '1')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "warning",
                        effect: "dark",
                        size: "mini",
                        class: "margin-left-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("转大货")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!['', '0'].includes(row.prodSwapSampleCount)
                  && row.state !== _ctx.PRODUCTION_DEMAND_STATUS_ENUM.CANCELED)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        type: "warning",
                        effect: "dark",
                        size: "mini",
                        class: "margin-left-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("大货样-" + _toDisplayString(row.prodSwapSampleCount), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (row.demandSource && row.demandSource !== '3')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 3,
                        type: row.demandSource === _ctx.DEMAND_CHANGE_ENUM.OEM ? '' : 'success',
                        effect: "dark",
                        size: "mini",
                        class: "margin-left-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.DEMAND_CHANGE_LIST, row.demandSource)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "订单类型",
              "min-width": "100",
              prop: "demandTaskType",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.DEMAND_TASK_TYPE_LIST, row.demandTaskType || '3')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "客户",
              "min-width": "100",
              prop: "purchaserName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "款式品类",
              "min-width": "120",
              prop: "styleTypeName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "生产信息",
              "min-width": "160",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", null, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.PRODUCTION_PATTERN_LIST, row.productionPattern)), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_4,
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'text-color-primary': !row.firstOrder })
                    }, _toDisplayString(row.firstOrder ? '首单' : '返单'), 3)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(row.orderCount), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_6,
                    _createElementVNode("span", null, _toDisplayString(row.orderCode || '-'), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              "min-width": "80",
              prop: "state",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.PRODUCTION_DEMAND_STATUS_LIST, row.state)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "核价情况",
              "min-width": "200",
              prop: "pricingStatus",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.skcInfoList, (item) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: item.skcId,
                    class: _normalizeClass([_ctx.getPricingStateClass(item.pricingStatus), 'align-left'])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.color) + "[" + _toDisplayString(item.designCode) + "]：", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.PRICING_STATUS_LIST, item.pricingStatus)), 1)
                  ], 2))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "接单情况",
              "min-width": "80",
              prop: "orderTakingState",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.YES_OR_NO_NUMBER_LIST, row.orderTakingState) || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "合同签署情况",
              "min-width": "100",
              prop: "contractSignStatus",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.CONTRACT_STATUS_LIST, row.contractSignStatus) || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "生产资料录入",
              "min-width": "100",
              prop: "materialUploadStatus",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getDataInputStatusClass(row.materialUploadStatus))
                }, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.DATA_INPUT_STATUS_LIST, row.materialUploadStatus) || '-'), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "创建时间",
              "min-width": "120",
              prop: "createdTime",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(row.createdTime, 'YYYY-MM-DD HH:mm')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "首次提交时间",
              "min-width": "120",
              prop: "submitTime",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$filters.formatTime(row.submitTime, 'YYYY-MM-DD HH:mm')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作日志",
              "min-width": "100",
              align: "center",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (_ctx.handleLog(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看日志")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["height", "data"])), [
          [_directive_loading, _ctx.tableLoading]
        ])
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              size: _ctx.params.pageSize,
              onCurrentChange: _ctx.handleCurrentChange,
              onSizeChange: _ctx.handleSizeChange
            }, null, 8, ["total", "current-page", "size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Logger, {
      modelValue: _ctx.logVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.logVisible) = $event)),
      ref: "productionLogRef",
      type: "PRODUCTION"
    }, null, 8, ["modelValue"])
  ], 64))
}